import Axios from '@/components/api/axios.js'
/**********************************************************************************
 * 公告接口
 **********************************************************************************/
export default {
	/**
	 * 获取指定业主的公告信息(操作记录)
	 * @param {String} :userId
	 * @param {String} noticeClass 公告分类，抄表默认为'0'
	 * @param {String} noticeType 公告类型，配合分类使用 0:催缴 1:充值 2:退费 3:扣费 4:拉闸  5:合闸  6:开户  7:销户
	 */
	getUserNoticeLimit(userId, pageIndex, pageSize, noticeClass, noticeType, beginTime, endTime, success, failure) {
		Axios.post('/notice/getUserNoticeLimit.do', {
			userId,
			pageIndex,
			pageSize,
			noticeClass,
			noticeType,
			beginTime,
			endTime,
		}, success, failure)
	},
	/**
	 * 分页获取单位业主操作记录
	 * @param {String} unitId  
	 */
	getUnitNoticeLimit(unitId, pageIndex, pageSize, noticeClass, noticeType, beginTime, endTime,userName, success, failure) {
		Axios.post('/notice/getUnitNoticeLimit.do', {
			unitId,
			pageIndex,
			pageSize,
			noticeClass,
			noticeType,
			beginTime,
			endTime,
			userName,
		}, success, failure)
	},

	/**
	 * 分页获取单位业主补扣记录
	 * @param {String} unitId
	 */
	getCBMPLimit(unitId, pageIndex, pageSize, beginTime, endTime,userName, success, failure) {
		Axios.post('/mackUp/getCBMPLimit.do', {
			unitId,
			pageIndex,
			pageSize,
			beginTime,
			endTime,
			userName,
		}, success, failure)
	},

	/**
	 * 单位业主操作记录导出
	 * @param {String} unitId
	 */
	exportUnitNotice(unitId, noticeClass, noticeType, beginTime, endTime,userName, success, failure) {
		Axios.post('/notice/exportUnitNotice.do', {
			unitId,
			noticeClass,
			noticeType,
			beginTime,
			endTime,
			userName,
		}, success, failure)
	},


	/**
	 * 单位业主补扣记录导出
	 * @param {String} unitId
	 */
	exportUnitMakeUp(unitId,beginTime, endTime,userName, success, failure) {
		Axios.post('/mackUp/exportUserCBMP.do', {
			unitId,
			beginTime,
			endTime,
			userName,
		}, success, failure)
	},

}